var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vi-alert',{class:_vm.name,attrs:{"type":"warning","show-icon":"","closable":false}},[_c('template',{slot:"title"},[_vm._v("\n    "+_vm._s(_vm.$t('module_creative_add_on_product_tiles_num_warning'))+"\n  ")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }